// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"95de8ca7","432":"fb915a7f","625":"05269350","925":"f4d8478d","937":"f3eda30c"}[chunkId] + ".css";
};